/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import abstractCaseTranslations from "./abstractCaseTranslations";

const pendingCaseTranslations = {
  label: "Vorläufiger Fall",
  ...abstractCaseTranslations,
  initialClientDescriptionAndObjectives: {
    label: "Anliegen Mandantschaft",
  },
  aiRefinementQuestions: {
    label: "Nachfragen zum Anliegen",
  },
  refinementAnswers: {
    label: "Antworten der Mandantschaft zu den Nachfragen",
  },
};

export default pendingCaseTranslations;
